import { EntityType } from "../models/entityType";

export function entityTypeDtoToEntity(entityType: any): EntityType {
  return {
    id: entityType.id,
    name: entityType.name,
  };
}
